import './blocks/cards/card-destination';
import './blocks/cards/card-double';
import './blocks/cards/card-offer';
import './blocks/cards/card-opportunity';

import './blocks/containers/banner-container';
import './blocks/containers/container';

import './blocks/content/featured-video';
import './blocks/content/partner-section';

import './blocks/hero-slider.js';
import './blocks/hero-slide.js';